/**
 * Created by ZhangJunPeng on 2017/5/22.
 */


import React from 'react';
import classNames from 'classnames';
import { defineMessages } from 'react-intl';
import moment from 'moment';
import PromptInfo from '../../utils/promptInfo';
import { MAINTAIN_STATUS, ROLES_KEY } from '../../utils/constants';
import PropTypes from 'prop-types';

const DialogType = PromptInfo.DialogType;
const messages = defineMessages({
  roomClose: {
    id: 'search_room_close'
  }
});

class TimeDiv extends React.Component {
  constructor(props) {
    super(props);
    this.handleAddScrollTop = this.handleAddScrollTop.bind(this);
    this.handleSubtractionScrollTop = this.handleSubtractionScrollTop.bind(
      this
    );
    this.handleAddScrollTopOnMouseDown = this.handleAddScrollTopOnMouseDown.bind(
      this
    );
    this.handleSubtractionScrollTopOnMouseDown = this.handleSubtractionScrollTopOnMouseDown.bind(
      this
    );
    this.handleMouseUp = this.handleMouseUp.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleUnSelect = this.handleUnSelect.bind(this);
    this.isShowArrow = this.isShowArrow.bind(this);
    this.checkRoomStatus = this.checkRoomStatus.bind(this);
    //todo
    this._user = JSON.parse(sessionStorage.getItem('userInfo'));
    this.state = {
      needRoll: false,
      roomClose: false,
      isSelect: false,
      isCurrent: false,
      isCurrentFirst: false,
      isCurrentLast: false
    };
  }

  componentDidMount() {
    this.isShowArrow();
    this.checkCurrentTime();
  }

  isShowArrow() {
    if (this._div && !this.state.needRoll) {
      const divs = this._div.children;
      let meetingsHeight = 0;
      let index = 0;
      for (let v in divs) {
        if (divs.hasOwnProperty(v)) {
          index++;
          meetingsHeight += divs[v].clientHeight;
        }
      }
      meetingsHeight = meetingsHeight + index * 4;
      if (this._div && meetingsHeight > this._li.clientHeight) {
        this.setState({ needRoll: true });
      }
    }
  }

  componentDidUpdate() {
    this.isShowArrow();
  }

  handleAddScrollTop(e) {
    e.stopPropagation();
    this._div.scrollTop = this._div.scrollTop + 10;
  }

  handleSubtractionScrollTop(e) {
    e.stopPropagation();
    this._div.scrollTop = this._div.scrollTop - 10;
  }

  handleAddScrollTopOnMouseDown(e) {
    e.stopPropagation();
    this._timer = setInterval(
      function() {
        this._div.scrollTop = this._div.scrollTop + 10;
      }.bind(this),
      100
    );
  }

  handleSubtractionScrollTopOnMouseDown(e) {
    e.stopPropagation();
    this._timer = setInterval(
      function() {
        this._div.scrollTop = this._div.scrollTop - 10;
      }.bind(this),
      100
    );
  }

  handleMouseUp() {
    clearInterval(this._timer);
  }

  checkCurrentTime = () => {
    const { index, timeMap, searchResults, room } = this.props;
    if (
      timeMap.get(index).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')
    ) {
      this.setState({ isCurrent: true });
      if (room.id === searchResults.list[0].id) {
        this.setState({ isCurrentFirst: true });
      }
      if (room.id === searchResults.list[searchResults.list.length - 1].id) {
        this.setState({ isCurrentLast: true });
      }
    }
  };

  handleClick(roomOpen, passedDay, isHoliday) {
    if (roomOpen && !passedDay && !isHoliday) {
      const { index, timeMap, handleByClickDay, roomID } = this.props;
      this.setState({ isSelect: true });
      handleByClickDay(timeMap.get(index), roomID, this.handleUnSelect);
    }
  }

  handleUnSelect() {
    this.setState({ isSelect: false });
  }

  checkRoomStatus() {
    const { searchResults, index, timeMap, room, holidays } = this.props;
    const days = searchResults.data.day.replace('7', '0');
    const roomTime = days.indexOf(timeMap.get(index).day()) !== -1;
    const roomStatus = room.open === 0 && room.status === 0;
    const userStatus =
      room.open === 1 && this._user.roleKey === ROLES_KEY.room_admin;
    // 判断是否是过去的日期 Wwei 2018-06-14
    const today = moment().startOf('day');
    const passedDay = timeMap.get(index).isBefore(today);
    const dateStr = timeMap.get(index).format('YYYY-MM-DD');
    const isHoliday = holidays.some(x => x.dayTimeFormat == dateStr);
    const currentMoment = timeMap.get(index);
    const nextMoment = moment(timeMap.get(index)).add(1, 'days').subtract(1, 'seconds');
    let roomMaintain = false;
    if (MAINTAIN_STATUS.not_set !== room.maintainStatus && room.startMaintainTime && room.endMaintainTime
      && !moment(room.startMaintainTime).isAfter(currentMoment) && !moment(room.endMaintainTime).isBefore(nextMoment)) {
      roomMaintain = true;
    }
    return {
      roomOpen: !roomMaintain && roomTime && (roomStatus || userStatus),
      passedDay,
      isHoliday
    };
  }

  render() {
    const { meetingsDiv } = this.props;
    const { roomOpen, passedDay, isHoliday } = this.checkRoomStatus();
    const divClass = classNames({
      'day-select-border': !this.state.roomClose && this.state.isSelect,
      not_available: !roomOpen || passedDay || isHoliday,
      'day-select-current': this.state.isCurrent,
      'day-select-current-first': this.state.isCurrentFirst,
      'day-select-current-last': this.state.isCurrentLast
    });
    return (
      <li
        onClick={() => this.handleClick(roomOpen, passedDay, isHoliday)}
        ref={c => (this._li = c)}
        className={divClass}
      >
        {!roomOpen && <i className="iconfont icon-x" />}
        {this.state.needRoll && (
          <div className="table-up">
            <i
              className="iconfont icon-up"
              onMouseDown={this.handleSubtractionScrollTopOnMouseDown}
              onClick={this.handleSubtractionScrollTop}
              onMouseUp={this.handleMouseUp}
              onMouseOut={this.handleMouseUp}
            />
          </div>
        )}

        {meetingsDiv.length > 0 && (
          <div className="week-available" ref={c => (this._div = c)}>
            {meetingsDiv}
          </div>
        )}
        {this.state.needRoll && (
          <div className="table-down">
            <i
              className="iconfont icon-down"
              onMouseDown={this.handleAddScrollTopOnMouseDown}
              onClick={this.handleAddScrollTop}
              onMouseUp={this.handleMouseUp}
              onMouseOut={this.handleMouseUp}
            />
          </div>
        )}
      </li>
    );
  }
}

TimeDiv.propTypes = {
  meetingsDiv: PropTypes.array,
  index: PropTypes.number.isRequired,
  timeMap: PropTypes.object.isRequired,
  handleByClickDay: PropTypes.func.isRequired,
  roomID: PropTypes.number.isRequired
};

export default TimeDiv;



// WEBPACK FOOTER //
// ./src/components/meeting/TimeDiv.js